import React, {useMemo} from "react";
import {Descriptions, Table} from "antd";

import {useTranslation} from "react-i18next";

export const CourierSummaryZoneInformation = ({zoneInfo}) => {
    const {t} = useTranslation(["courierDetail"]);

    return (
        <>
            {zoneInfo && zoneInfo?.length > 0 && (
                <Table
                    size="small"
                    pagination={{
                        hideOnSinglePage: true,
                        showSizeChanger: false
                    }}
                    dataSource={zoneInfo}
                    columns={[
                        {title: "Bölge Müdürlüğü", dataIndex: "zoneManagementName"},
                        {title: "Bölge", dataIndex: "zoneName"}
                    ]}
                />
            )}
        </>
    );
};
